import { DialogRef } from '@aca-new/app/shared/components/modal/shared/classes/dialog.ref';
import { DialogCommonModule } from '@aca-new/app/shared/components/modal/shared/components/dialog-common/dialog-common.module';
import { PRIVACY_POLICY, TERMS_CONDITIONS } from '@aca-new/app/shared/constants/app.constants';
import { IMAGES } from '@aca-new/app/shared/constants/images.constants';
import { IMyWindow } from '@aca-new/app/shared/interfaces/my-window.interface';
import { QimaButtonService } from '@aca-new/app/shared/services/exported-services/qima-button/qima-button.service';
import { QimaIconService } from '@aca-new/app/shared/services/exported-services/qima-icon/qima-icon.service';
import { AppUserSettingService } from '@aca-new/app/shared/services/user-services/app-user-setting/app-user-setting.service';
import { WINDOW } from '@aca-new/app/shared/tokens/window.token';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { QimaButtonModule } from '@qima/ngx-qima';

@Component({
  selector: 'app-user-guide',
  templateUrl: './user-guide.component.html',
  styleUrls: ['./user-guide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [DialogCommonModule, TranslateModule, QimaButtonModule],
})
export class UserGuideComponent<T> {
  public readonly helpGuidePicture: string = IMAGES.helpGuide;
  public readonly plankPicture: string = IMAGES.plank;
  public readonly termsConditionsLink: string;
  public readonly privicyPolicyLink: string;
  private readonly _isCn = location.origin.includes('.cn');

  public constructor(
    @Inject(DialogRef) private readonly _dialogRef: DialogRef<T>,
    @Inject(WINDOW) private readonly _window: IMyWindow,
    private readonly _appUserSettingService: AppUserSettingService,
    public readonly qimaButton: QimaButtonService,
    public readonly qimaIcon: QimaIconService
  ) {
    this.termsConditionsLink = this.getLink(TERMS_CONDITIONS);
    this.privicyPolicyLink = this.getLink(PRIVACY_POLICY);
  }

  public getLink(link: string): string {
    return this._isCn ? link.replace('.com', '.cn') : link;
  }

  public onDownloadPdfClick(): void {
    const cpUserGuideUrl = 'https://static.files.qima.com/legacy/qima/myQIMA_User_Guide_2024.pdf';
    const foodCertUserGuideUrl = 'https://static.files.qima.com/food-cert/myQIMA_FoodCert_User_Guide_v1.pdf';
    const guideUrl = this._appUserSettingService.getEnableFoodCertification() ? foodCertUserGuideUrl : cpUserGuideUrl;

    this._window.open(guideUrl);
  }

  public onCloseClick(): void {
    this._dialogRef.close();
  }
}
